import * as React from 'react';
import { Chip as MuiChip, ChipProps as MuiChipProps } from '@material-ui/core';
import { Theme } from '@emotion/react';
import { chipBase, chipColor } from 'bento/Chip/chipCssDefs';

export interface ChipProps
  extends Omit<
    MuiChipProps,
    'color' | 'size' | 'variant' | 'clickable' | 'onClick' | 'disabled' | 'onDelete'
  > {
  /**
   * Color of the component. Expanded to include success, warning, and internal
   */
  color:
    | 'primary'
    | 'subtle'
    | 'success'
    | 'warning'
    | 'danger'
    | 'internal'
    | 'featureGate'
    | 'gda';
}

/**
 * Bento flavored Chip component with additional color themes.
 *
 * Demo:
 * [Storybook](http://tock-assets.tocktix.com/styleguide/dashboard/?path=/docs/components-chip--playground)
 * @deprecated Deprecated — use pantry Tag instead.
 * @see https://docs.tocktix.com/pantry?path=/docs/components-tag--docs
 * Migration: Replace Chip with the pantry Tag component.
 */
export const Chip = React.forwardRef<HTMLDivElement, ChipProps>(
  ({ className, color, label, icon, ...rest }, ref) => {
    const isIconOnly = !label && typeof label !== 'number';
    const sizedIcon = React.isValidElement(icon)
      ? React.cloneElement(icon as React.ReactElement<{ size?: number }>, { size: 100 })
      : icon;

    return (
      <MuiChip
        className={className}
        css={(theme: Theme) => [chipBase(theme, isIconOnly), chipColor(theme, color)]}
        label={label}
        icon={sizedIcon}
        size="small"
        variant="default"
        data-testid="chip"
        ref={ref}
        {...rest}
      />
    );
  }
);
